<template>
  <section class="main-visual-info-wrap">
      <div class="main-visual-info">
        <img
          :class="{ 'mobile-logo': isMobile }"
          :src="logoImage"
          alt="5월 동행축제에 참여해주셔서 진심으로 감사드립니다. 9월 동행축제에도 많은 관심과 참여 부탁드리겠습니다. 동행축제 2024 5.1 ~ 5.30 K SHOPPING FESTA 중소벤처기업부, 한국중소벤처기업유통원, 소상공인시장진흥공단"
        />
      </div>
  </section>
</template>
<style>
    .main-visual-info-wrap .main-visual-info img {width:100%}
</style>
<script>
import { mapGetters } from "vuex";

export default {
  name: "MainLivePr",
  components: {},
  data: () => ({}),
  computed: {
    ...mapGetters("common", ["isMobile"]),
    logoImage() {
      if (this.isMobile) {
        return require("../../assets/img/main/mainEventEnd_moLogo_250604.png");
      } else {
        return require("../../assets/img/main/mainEventEnd_logo_20250613.png");
      }
    }
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>
